import Services from 'services';

class PenerimaanPettyCashApi {
  get(params) {
    return Services.get('approval_penerimaan_petty_cash/list', {
      params,
    });
  }

  getHistory(params) {
    return Services.get('approval_penerimaan_petty_cash/history/list', {
      params,
    });
  }

  getSingle(params) {
    return Services.get('approval_penerimaan_petty_cash/detail', {
      params,
    });
  }

  approve(data) {
    return Services.post('approval_penerimaan_petty_cash/approve', data);
  }
}

export default new PenerimaanPettyCashApi();
